._sectionHeader_zwhoj_1 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 36px 24px 12px; }
